import React from "react";
import { Row, Col, Input, Button, Drawer } from "antd";
import { Scrollbars } from "react-custom-scrollbars";
import Close from "../../../../assets/images/close-x.svg";
import SearchIcon from "../../../../assets/images/searchIcon.svg";

const GiftCardSelectionDrawer = ({
  isGiftCardFlag,
  setIsGiftCardFlag,
  giftCardType,
  setGiftCardType,
  searchTerm,
  setSearchTerm,
  setValidateGiftCard,
  setGiftCardBalance,
  setOpen,
  setLayoutName,
  searchInputRef,
  selectBagRef,
  filteredGiftCards,
  selectGiftCard,
  keyboard,
  setInputName,
}) => {
  return (
    <Drawer
      closable={false}
      placement="bottom"
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "5vh",
            // marginTop: "2vh",
            fontSize: "1vw",
            padding: "1vw",
          }}
        >
          {/* <Input
            type="text"
            className="productSearch"
            placeholder="Search for gift cards"
            id="giftCardSearchInput"
            onPressEnter={() => (filteredGiftCards.length === 1 ? selectGiftCard(filteredGiftCards[0]) : null)}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: "250px",
              marginLeft: "1.8vw",
              padding: "5px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              fontSize: "1vw",
              color: "#0F0718",
              borderColor: "rgba(0, 0, 0, 0.25)",

            }}
            prefix={<img src={SearchIcon} alt="" style={{ width: "15px", height: "15px", paddingLeft: "0.2vw" }} />}
          /> */}
          <p
            style={{
              fontSize: "1.5em",
              fontWeight: "500",
              color: "#0F0718",
              flex: 1,
              textAlign: "center",
              paddingRight: "5vw",
            }}
          >
            {giftCardType}
          </p>
          <img
            src={Close}
            onClick={() => {
              setIsGiftCardFlag(false);
              setSearchTerm("");
              setValidateGiftCard(false);
              setGiftCardBalance("0.00");
              setOpen(false);
              setLayoutName("default");
              if (searchInputRef?.current) {
                searchInputRef?.current.focus();
              }
            }}
            style={{
              marginLeft: "auto",
              paddingBottom: "4vh",
              paddingTop: "2vh",
              cursor: "pointer",
              width: "1.5vw",
            }}
          />
        </div>
      }
      open={isGiftCardFlag}
      className="filter"
      closeIcon={null}
  styles={{
header: {
  borderBottom: "none",
  background: "#f3f4f9",
  minHeight: "11vh",
  display: "flex",
  alignItems: "center",
  padding: "0 1.5vw",
},
    body: {
      paddingBottom: 0,
      paddingTop: 0,
      background: "#f3f4f9",
    },
  }}
      // onClose={()=>setAddCashFlag(false)}
      //  id="sm-drawer-close"
      height="85vh"
      onClose={() => {
        setValidateGiftCard(false);
        setGiftCardBalance("0.00");
        setOpen(false);
        setLayoutName("default");
        if (searchInputRef?.current) {
          searchInputRef?.current.focus();
        }
      }}
    >
      <Row
        style={{
          marginTop: "2vh",
          marginLeft: "-0.1vw",
          borderRadius: "10px",
          padding: "0 1vw",
          paddingLeft: "5vw",
          fontSize: "1vw",
        }}
      >
        <Col span={10}>
          <Button.Group>
            <Button
              onClick={() => {
                setGiftCardType("Gift Card");
                setTimeout(() => {
                  selectBagRef.current.focus();
                  setSearchTerm("");
                }, 10);
              }}
              style={{
                backgroundColor: giftCardType === "Gift Card" ? "#2F3856" : "#fff",
                color: giftCardType === "Gift Card" ? "#fff" : "#929098",
                fontSize: "1em",
                fontWeight: "500",
                height: "4.8vh",
                borderRadius: "3px",
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                width: "10vw",
              }}
            >
              Gift Card
            </Button>
            <Button
              onClick={() => {
                (setGiftCardType("Voucher"),
                  setTimeout(() => {
                    if (selectBagRef?.current) {
                      selectBagRef.current.focus();
                    }
                    setSearchTerm("");
                  }, 10));
              }}
              style={{
                backgroundColor: giftCardType === "Voucher" ? "#2F3856" : "#fff",
                color: giftCardType === "Voucher" ? "#fff" : "#929098",
                fontSize: "1em",
                fontWeight: "500",
                height: "4.8vh",
                borderRadius: "3px",
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                width: "10vw",
              }}
            >
              Voucher
            </Button>
            <Button
              onClick={() => {
                (setGiftCardType("Credit Note"),
                  setTimeout(() => {
                    selectBagRef.current.focus();
                    setSearchTerm("");
                  }, 10));
              }}
              style={{
                backgroundColor: giftCardType === "Credit Note" ? "#2F3856" : "#fff",
                color: giftCardType === "Credit Note" ? "#fff" : "#929098",
                fontSize: "1em",
                fontWeight: "500",
                height: "4.8vh",
                borderRadius: "3px",
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                width: "10vw",
              }}
            >
              Credit Note
            </Button>
          </Button.Group>
        </Col>
        <Col span={6} />
        <Col span={5}>
          <Input
            type="text"
            className="productSearch"
            ref={selectBagRef}
            placeholder={`Search For ${giftCardType}`}
            id="sm-product-search"
            onPressEnter={() => (filteredGiftCards.length === 1 ? selectGiftCard(filteredGiftCards[0]) : null)}
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              keyboard?.current?.setInput(e.target.value);
            }}
            onFocus={() => {
              setInputName("giftCardInput");
              setTimeout(() => {
                setOpen(true);
                keyboard?.current?.setInput(searchTerm);
              }, 300);
            }}
            style={{
              width: "22.5vw",
              marginLeft: "1.8vw",
              padding: "5px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              fontSize: "1vw",
              color: "#0F0718",
              borderColor: "rgba(0, 0, 0, 0.25)",
              marginLeft: "3vw",
            }}
            prefix={
              <img
                src={SearchIcon}
                alt=""
                style={{
                  width: "15px",
                  height: "15px",
                  paddingLeft: "0.2vw",
                }}
              />
            }
          />
        </Col>
      </Row>

      <Scrollbars className="productScroll1" style={{ marginTop: "4vh" }}>
        <Row
          style={{
            marginLeft: "-0.1vw",
            borderRadius: "10px",
            padding: "0 1vw",
            fontSize: "1vw",
          }}
        >
          {filteredGiftCards?.map((obj, i) => (
            <Col
              push={1}
              span={7}
              pull={1}
              key={i}
              style={{
                backgroundColor: "#fff",
                padding: "2vh 2vw",
                borderRadius: "5px",
                marginRight: "1.5vw",
                marginBottom: "1.5vh",
                marginTop: "1.5vh",
              }}
            >
              <p style={{ marginBottom: "1.5vh", height: "11vh" }} className="productName">
                {/* {obj["name"]} */}
                <span
                  style={{
                    fontWeight: 500,
                    fontSize: "1.25em",
                    color: "#0F0718",
                  }}
                >
                  {obj["name"]}
                </span>
                <span
                  style={{
                    display: "block",
                    fontSize: "1em",
                    fontWeight: 400,
                    color: "#0F0718",
                  }}
                >
                  Code: {obj["value"]}
                </span>
              </p>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span style={{ fontWeight: 400, fontSize: "1em" }}>
                  Type: {obj?.matchingGiftCard?.length > 0 ? (obj?.matchingGiftCard[0]?.type === "PHY" ? "Physical" : "Digital") : ""}
                </span>
                <Button
                  onClick={() => selectGiftCard(obj)}
                  style={{
                    fontSize: "1em",
                    color: "#fff",
                    backgroundColor: "#2F3856",
                    padding: "0.3vh 2.3vw",
                    borderRadius: "3px",
                    cursor: "pointer",
                    fontWeight: 500,
                  }}
                >
                  ADD
                </Button>
              </div>
            </Col>
          ))}
        </Row>
      </Scrollbars>
    </Drawer>
  );
};

export default GiftCardSelectionDrawer;
